import { Grid, IconButton, Icon } from '@mui/material'
import { TextInput } from './TextInput'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  img: {
    backgroundColor: 'white',
  },
  gridItem: {
    backgroundColor: 'white',
    marginBottom: 10,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  grid: {
    padding: '0px 20px',
  },
})

type CaptchaInputProps = {
  captcha?: string
  getCaptcha: () => void
  errors: any
  control: any
}

export function CaptchaInput({
  captcha,
  getCaptcha,
  errors,
  control,
}: CaptchaInputProps) {
  const classes = useStyles()
  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        className="bg-white mb-2 rounded-md flex justify-center align-center"
      >
        <img
          src={`data:image/svg+xml;base64,${btoa(captcha || '')}`}
          alt="captcha"
          className={classes.img}
        />
        <IconButton
          color="secondary"
          aria-label="refresh captcha"
          component="span"
          onClick={getCaptcha}
        >
          <Icon className="fas fa-sync-alt" />
        </IconButton>
      </Grid>
      <Grid mt={1} item xs={12} sm={12}>
        <TextInput
          type="captcha"
          name="captcha"
          label="Confirm the captcha"
          variant="filled"
          autoComplete="off"
          errors={errors}
          control={control}
        />
      </Grid>
    </>
  )
}
